import { AppLanguage } from "@/lib/language";

const PT_TO_EN: Record<string, string> = {
  "Entrar": "Sign in",
  "Sair": "Log out",
  "Cancelar": "Cancel",
  "Contato": "Contact",
  "Recursos": "Features",
  "Preços": "Pricing",
  "Voltar": "Back",
  "Voltar para início": "Back to Home",
  "Voltar para o blog": "Back to blog",
  "Voltar ao topo": "Back to top",
  "Próxima": "Next",
  "Anterior": "Previous",
  "Ler artigo": "Read article",
  "Ler post em alta": "Read featured post",
  "Últimos artigos": "Latest articles",
  "Página não encontrada": "Page not found",
  "Loja não encontrada": "Store not found",
  "Loja": "Store",
  "Compre agora": "Buy Now",
  "Em breve": "Coming soon",
  "Nenhum produto disponível no momento.": "No products available yet.",
  "Feito com": "Made with",
  "Desenvolvido com Qlivar": "Powered by Qlivar",
  "Fale comigo": "Contact Me",
  "Fale com a gente": "Get in touch",
  "Enviar mensagem": "Send message",
  "Enviar": "Send",
  "Salvar": "Save",
  "Excluir": "Delete",
  "Editar": "Edit",
  "Carregando...": "Loading...",
  "Painel": "Dashboard",
  "Criar conta": "Create account",
  "Criar conta grátis": "Sign up for free",
  "Esqueceu a senha?": "Forgot password?",
  "Senha": "Password",
  "Nova senha": "New Password",
  "Confirmar senha": "Confirm Password",
  "Atualizar senha": "Update password",
  "Email": "Email",
  "Nome": "Name",
  "Assunto": "Subject",
  "Mensagem": "Message",
  "Produto": "Product",
  "Política de Privacidade": "Privacy Policy",
  "Termos de Serviço": "Terms of Service",
  "Política de Cookies": "Cookie Policy",
  "Última atualização": "Last updated",
  "Dashboard": "Dashboard",
  "Faturamento": "Billing",
  "Análises": "Analytics",
  "Aparência": "Appearance",
  "Perfil": "Profile",
  "Configurações": "Settings",
  "Afiliados": "Affiliates",
  "Correio": "Inbox",
  "Cliques": "Clicks",
  "Visualizações": "Views",
  "Sem dados de analytics ainda": "No Analytics Data Yet",
  "Compartilhe sua página para começar a rastrear visualizações e cliques": "Share your page to start tracking views and clicks",
  "Analytics avançado": "Advanced Analytics",
  "Sem dados de analytics avançado ainda": "No Advanced Analytics Data Yet",
  "Compartilhe sua página para começar a coletar insights detalhados": "Share your page to start collecting detailed insights",
  "Cobertura": "Coverage",
  "Seu links": "Your Links",
  "Seus links": "Your Links",
  "Adicionar link": "Add Link",
  "Sem links ainda": "No links yet",
  "Título": "Title",
  "Sem ícone": "No icon",
  "Ícone (opcional)": "Icon (optional)",
  "Cores personalizadas (opcional)": "Custom Colors (optional)",
  "Fundo": "Background",
  "Texto": "Text",
  "Posição da imagem": "Image Position",
  "Editar link": "Edit Link",
  "Upload de foto": "Upload photo",
  "Sua prévia ao vivo": "Live Preview",
  "Prévia ao vivo": "Live Preview",
  "Sua página pública": "Your public page",
  "Seus links aparecerão aqui": "Your links will appear here",
  "Página publicada com sucesso": "Page published successfully",
  "Página movida para rascunho": "Page moved to draft mode",
  "Falha ao atualizar status de publicação": "Failed to update publish status",
  "Prévia": "Preview",
  "Compartilhar prévia": "Share Preview",
  "Opções de prévia e compartilhamento": "Preview & Sharing Options",
  "Link de prévia compartilhável": "Share Preview Link",
  "Janela de visibilidade": "Visibility window",
  "Visível a partir de": "Visible from",
  "Visível até": "Visible until",
  "Data": "Date",
  "Hora": "Time",
  "Ativo": "Active",
  "Verificando": "Verifying",
  "Configuração pendente": "Pending Setup",
  "Falhou": "Failed",
  "Domínio customizado": "Custom Domain",
  "Remover domínio customizado?": "Remove custom domain?",
  "Configure seu DNS:": "Configure your DNS settings:",
  "Tipo: CNAME": "Type: CNAME",
  "Nome:": "Name:",
  "Valor:": "Value:",
  "Seu domínio": "Your Domain",
  "Como funciona:": "How it works:",
  "Insira seu domínio acima": "Enter your domain above",
  "Adicione um CNAME apontando para qlivar.com": "Add a CNAME record pointing to qlivar.com",
  "Aguarde propagação de DNS (até 48 horas)": "Wait for DNS propagation (up to 48 hours)",
  "Sua bio page ficará ativa no seu domínio!": "Your bio page will be live on your domain!",
  "Análises da loja": "Store Analytics",
  "Últimos 7 dias": "Last 7 days",
  "Últimos 30 dias": "Last 30 days",
  "Todo período": "All time",
  "Visitas": "Visits",
  "Cliques de compra": "Buy Clicks",
  "CTR": "CTR",
  "Visão geral do tráfego": "Traffic Overview",
  "Top produtos por cliques": "Top Products by Clicks",
  "Link na bio da loja": "Store Link on Bio Page",
  "Exibir link para sua loja na bio": "Show a link to your store on your bio page",
  "Título da página da loja": "Store Page Title",
  "Texto do botão": "Button Text",
  "Produtos": "Products",
  "Gerencie seus produtos e conecte pagamentos externos.": "Manage your products and link to external payments.",
  "Nome *": "Name *",
  "Descrição": "Description",
  "Preço": "Price",
  "Moeda": "Currency",
  "Imagem do produto": "Product Image",
  "Clique para enviar (máx 5MB)": "Click to upload (max 5MB)",
  "Link de pagamento": "Payment Link",
  "Sem produtos ainda": "No Products Yet",
  "Adicione produtos para exibir na sua loja.": "Add products to showcase in your store.",
  "Excluir produto?": "Delete product?",
  "Assinatura ativada com sucesso": "Subscription activated successfully",
  "Checkout de assinatura cancelado": "Subscription checkout canceled",
  "Falha ao sair": "Failed to sign out",
  "Saída realizada com sucesso": "Signed out successfully",
  "Carregando seu dashboard...": "Loading your dashboard...",
  "Sair da conta?": "Sign out?",
  "Você precisará entrar novamente para acessar seu dashboard.": "You will need to sign in again to access your dashboard.",
  "Bem-vindo de volta": "Welcome back",
  "Veja como sua bio page está performando.": "Here's how your bio page is performing.",
  "Seletor de data": "Date picker",
  "Fontes": "Sources",
  "Países": "Countries",
  "Fonte principal": "Top Source",
  "País principal": "Top Country",
  "Desktop": "Desktop",
  "Mobile": "Mobile",
  "Tablet": "Tablet",
  "Navegador principal": "Top Browser",
  "Sem fontes de tráfego ainda": "No Traffic Sources Yet",
  "Compartilhe seu link para começar a rastrear referenciadores": "Share your link to start tracking referrers",
  "Sem dados geográficos ainda": "No Geographic Data Yet",
  "Aguardando visitantes de diferentes regiões": "Waiting for visitors from around the world",
  "Sem dados de dispositivo ainda": "No Device Data Yet",
  "Dados de dispositivo aparecerão quando visitantes chegarem": "Device info will appear as visitors arrive",
  "Sem dados de navegador ainda": "No Browser Data Yet",
  "Estatísticas de navegador aparecerão quando visitantes chegarem": "Browser stats will populate as visitors arrive",
  "Sem dados de links ainda": "No Link Data Yet",
  "Adicione links e compartilhe sua página!": "Add some links and share your page!",
  "Conta": "Account",
  "Nome de exibição": "Display Name",
  "Senha atual": "Current Password",
  "Confirmar nova senha": "Confirm New Password",
  "Excluir conta": "Delete Account",
  "Tem certeza absoluta?": "Are you absolutely sure?",
  "Seu nome": "Your name",
  "Conte para sua audiência sobre você...": "Tell your audience about yourself...",
  "Domínio salvo! Siga as instruções de DNS abaixo.": "Domain saved! Follow the DNS instructions below.",
  "Domínio removido com sucesso": "Domain removed successfully",
  "Copiado para a área de transferência!": "Copied to clipboard!",
  "Insira um domínio válido (ex.: links.seusite.com)": "Please enter a valid domain (e.g., links.yoursite.com)",
  "Falha ao salvar domínio. Tente novamente.": "Failed to save domain. Please try again.",
  "Falha ao remover domínio": "Failed to remove domain",
  "Falha ao carregar inscritos": "Failed to load subscribers",
  "Inscrito removido": "Subscriber removed",
  "Falha ao remover inscrito": "Failed to remove subscriber",
  "Inscritos exportados": "Subscribers exported",
  "Falha ao exportar inscritos": "Failed to export subscribers",
  "Título do formulário": "Form Title",
  "Descrição do formulário": "Description",
  "Posição do formulário": "Form Position",
  "Topo (antes dos links)": "Top (Before Links)",
  "Rodapé (depois dos links)": "Bottom (After Links)",
  "Ambos": "Both",
  "Inscritos ativos": "Active Subscribers",
  "Total de inscritos": "Total Subscribers",
  "Inscritos": "Subscribers",
  "Sem inscritos ainda": "No Subscribers Yet",
  "Remover inscrito?": "Remove subscriber?",
  "A/B Testing": "A/B Testing",
  "Tráfego alocado": "Traffic Allocated",
  "Variante nova": "New Variant",
  "Nome da variante": "Variant Name",
  "Percentual de tráfego": "Traffic Percentage",
  "Tema": "Theme",
  "Cor sólida": "Solid Color",
  "Início": "Start",
  "Fim": "End",
  "Aplicar filtro de cor": "Apply Color Filter",
  "Opacidade do filtro": "Filter Opacity",
  "Cor do botão": "Button Color",
  "Cor do texto": "Text Color",
  "Mostrar avatar": "Show Avatar",
  "Mostrar bio": "Show Bio",
  "Feito para creators que levam o negócio a sério": "Built for creators who mean business",
  "Um link.": "One link.",
  "Ilimitadas": "Unlimited",
  "possibilidades!": "possibilities!",
  "A link-in-bio que realmente ajuda você a crescer. Design limpo, analytics inteligente e monetização embutida —": "The link-in-bio that actually helps you grow. Clean design, smart analytics, and built-in monetization —",
  "comece grátis e evolua conforme cresce.": "start for free, upgrade as you grow.",
  "Começar grátis": "Start building for free",
  "Ver em ação": "See it in action",
  "✓ Comece grátis — sem cartão de crédito ✓ Setup em 60 segundos ✓ Upgrade só quando quiser": "✓ Start free — no credit card needed   ✓ Setup in 60 seconds   ✓ Upgrade only when you're ready",
  "Crescimento de creator": "Creator Growth",
  "Promova conteúdo, ofertas e lead magnets em uma bio page focada.": "Promote content, offers, and lead magnets in one focused bio page.",
  "Geração de leads": "Lead Generation",
  "Transforme tráfego de perfil em calls qualificadas e inscritos por e-mail.": "Turn profile traffic into qualified calls and email subscribers.",
  "Foco em vendas": "Sales Focus",
  "Mostre produtos e campanhas com CTAs claros de alta intenção.": "Showcase products and campaigns with clear high-intent CTAs.",
  "Creator digital e coach": "Digital creator & coach",
  "Consultor de negócios": "Business consultant",
  "Marca creator": "Creator brand",
  "Tudo o que você precisa. Nada do que não precisa.": "Everything you need. Nothing you don't.",
  "Removemos o excesso. O que ficou foi uma ferramenta focada em ajudar creators a crescer e monetizar.": "We stripped away the bloat. What's left is a laser-focused tool that helps creators grow and monetize.",
  "Rápido como um raio": "Lightning Fast",
  "As páginas carregam em menos de 100ms. Sem bloat, sem lag — apenas acesso instantâneo para sua audiência.": "Pages load in under 100ms. No bloat, no lag — just instant access for your audience.",
  "Analytics acionável": "Actionable Analytics",
  "Saiba exatamente o que funciona. Acompanhe cliques, visualizações e conversões com clareza.": "Know exactly what's working. Track clicks, views, and conversions with clarity.",
  "Temas lindos": "Beautiful Themes",
  "Destaque-se com designs incríveis. Customize cores, fontes e layouts em segundos.": "Stand out with stunning designs. Customize colors, fonts, and layouts in seconds.",
  "Monetização embutida": "Built-in Monetization",
  "Venda produtos, receba gorjetas ou aceite pagamentos direto da sua bio page.": "Sell products, collect tips, or accept payments directly from your bio page.",
  "Mobile first": "Mobile-First",
  "Desenhado para onde sua audiência está. Perfeito em qualquer dispositivo.": "Designed for where your audience lives. Pixel-perfect on every device.",
  "Foco em privacidade": "Privacy Focused",
  "Seus dados continuam seus. Sem scripts invasivos, sem vender seus analytics.": "Your data stays yours. No tracking scripts, no selling your analytics.",
  "Construído para a forma como creators modernos vendem e crescem": "Built for the way modern creators sell and grow",
  "Casos de uso feitos para resultado": "Use cases built for outcomes",
  "Pare de mandar sua audiência para páginas genéricas de links. Dê uma experiência focada para aumentar confiança, cliques e receita.": "Stop sending your audience to generic link pages. Give them a focused experience designed to increase trust, clicks, and revenue.",
  "Músicos e artistas": "Musicians & Artists",
  "Lance faixas, merch, ingressos e drops exclusivos em uma única página de alta conversão.": "Launch tracks, merch, tickets, and exclusive drops in one high-converting page that keeps fans engaged.",
  "Lançamentos que convertem": "Launches that convert",
  "Creators digitais": "Digital Creators",
  "Transforme tráfego de perfil em inscritos, leads e clientes com estrutura inteligente de links e analytics embutido.": "Turn profile traffic into subscribers, leads, and customers with smarter link structure and built-in analytics.",
  "Motor de crescimento de audiência": "Audience growth engine",
  "Coaches e consultores": "Coaches & Consultants",
  "Troque links espalhados por um hub premium que gera confiança e mais calls qualificadas.": "Replace scattered links with a premium hub that builds trust and drives discovery calls and paid sessions.",
  "Mais reuniões qualificadas": "More qualified bookings",
  "Pequenas marcas": "Small Brands",
  "Rode campanhas, destaque produtos e ofertas sazonais em um destino de marca otimizado para ação.": "Run campaigns, product highlights, and seasonal offers from one branded destination optimized for action.",
  "Vitrine pronta para campanhas": "Campaign-ready storefront",
  "Construído como um motor moderno de crescimento": "Built like a modern growth engine",
  "Cada parte do Qlivar foi desenhada para melhorar confiança, cliques e monetização — sem complexidade.": "Every part of Qlivar is designed to improve trust, clicks, and monetization — without adding complexity to your workflow.",
  "Capture atenção em segundos": "Capture attention in seconds",
  "A maioria dos visitantes decide em poucos segundos. O Qlivar entrega uma página limpa e moderna que destaca suas melhores ofertas.": "Most visitors decide in a few seconds. Qlivar gives you a clean, modern page that highlights your top offers and makes clicks feel natural.",
  "Hierarquia clara que guia a próxima ação": "Clear hierarchy that guides the next action",
  "Experiência mobile-first para tráfego social": "Mobile-first experience for social traffic",
  "Carregamento rápido para reduzir abandono": "Fast load time to reduce drop-offs",
  "Transforme tráfego de perfil em receita": "Turn profile traffic into revenue",
  "Não envie seguidores para múltiplas ferramentas. Mantenha ofertas, produtos e captura de leads em um fluxo focado em conversão.": "Don’t send followers through multiple tools. Keep offers, products, and lead capture in one conversion-focused flow.",
  "Mini-loja para ofertas e produtos": "Mini-store for direct offers and products",
  "CTA mais forte para maior intenção": "Stronger CTA placement for higher intent",
  "Analytics embutido para otimizar vendas": "Built-in analytics to optimize what sells",
  "Construa uma marca em que as pessoas confiam": "Build a brand people trust",
  "Uma apresentação premium aumenta a credibilidade com marcas, clientes e patrocinadores.": "A premium presentation increases credibility with brands, clients, and sponsors. Use polished visuals and your own domain to stand out.",
  "Temas personalizados com visual profissional": "Custom themes with professional look",
  "Consistência de marca em todos os links": "Brand consistency across all links",
  "Domínio personalizado para mais autoridade": "Custom domain-ready for stronger authority",
  "Perguntas? Respostas.": "Questions? Answers.",
  "Tudo o que você precisa saber sobre o Qlivar.": "Everything you need to know about qlivar.",
  "Como o qlivar é diferente do Linktree?": "How is qlivar different from Linktree?",
  "Posso usar meu próprio domínio?": "Can I use my own domain?",
  "Quais métodos de pagamento vocês aceitam?": "What payment methods do you accept?",
  "Posso vender produtos diretamente na minha página?": "Can I sell products directly on my page?",
  "O que acontece se eu fizer downgrade ou cancelar?": "What happens if I downgrade or cancel?",
  "Vocês oferecem reembolso?": "Do you offer refunds?",
  "Ainda tem dúvidas?": "Still have questions?",
  "— vamos adorar ajudar.": "— we'd love to help.",
  "Sua audiência merece": "Your audience deserves",
  "melhor.": "better.",
  "Junte-se a milhares de creators que trocaram páginas básicas por resultados reais. Crie sua página em 60 segundos —": "Join thousands of creators who've upgraded from basic bio links. Create your page in 60 seconds —",
  "comece grátis hoje.": "start for free today.",
  "Sem cartão de crédito. Sem trial. Sem pegadinha.": "No credit card required. No trial. No catch.",
  "Faça upgrade só quando quiser.": "Upgrade only when you want to.",
  "Amado por creators": "Loved by creators",
  "Não confie só na nossa palavra. Veja o que usuários reais dizem.": "Don't take our word for it. Here's what real users have to say.",
  "Mais popular": "Most Popular",
  "Seu plano": "Your Plan",
  "Abrindo checkout...": "Opening checkout...",
  "Plano atual": "Current Plan",
  "Downgrade": "Downgrade",
  "Cancelar quando quiser • Sem taxas escondidas": "Cancel anytime • No hidden fees",
  "Todos os planos incluem SSL, 99,9% de uptime e CDN global rápido. Cancele quando quiser.": "All plans include SSL, 99.9% uptime, and lightning-fast global CDN. Cancel anytime.",
  "Construído como um motor moderno de": "Built like a modern",
  "crescimento": "growth engine",
  "Amado por": "Loved by",
  "criadores": "creators",
  "Comece grátis": "Get started for free",
  "Tudo o que você precisa.": "Everything you need.",
  "Nada do que não precisa.": "Nothing you don't.",
  "Construído para a forma como creators modernos": "Built for the way modern",
  "creators vendem e crescem": "creators sell and grow",
  "Perguntas?": "Questions?",
  "Respostas.": "Answers.",
  "A maioria dos visitantes decide em poucos segundos. O Qlivar entrega uma página limpa e moderna que destaca suas melhores ofertas e torna o clique natural.": "Most visitors decide in a few seconds. Qlivar gives you a clean, modern page that highlights your top offers and makes clicks feel natural.",
  "Uma apresentação premium aumenta a credibilidade com marcas, clientes e patrocinadores. Use visuais refinados e seu próprio domínio para se destacar.": "A premium presentation increases credibility with brands, clients, and sponsors. Use polished visuals and your own domain to stand out.",
  "Crescimento de Criador": "Creator Growth",
  "🎵 Novo EP lançado": "🎵 New EP Out Now",
  "📚 Guia grátis para creators": "📚 Free Creator Guide",
  "💼 Agendar call": "💼 Book a Call",
  "🛍️ Loja de merch": "🛍️ Shop Merch",
  "Geração de Leads": "Lead Generation",
  "📞 Agendar sessão estratégica": "📞 Book Strategy Session",
  "📈 Baixar plano de crescimento": "📈 Download Growth Plan",
  "✅ Resultados de clientes": "✅ Client Results",
  "✉️ Entrar na newsletter": "✉️ Join Newsletter",
  "Loja Qlivar": "Qlivar Store",
  "🔥 Oferta da semana": "🔥 Weekly Offer",
  "🛒 Mais vendidos": "🛒 Best Sellers",
  "🎁 Combos especiais": "🎁 Bundle Deals",
  "⭐ Avaliações de clientes": "⭐ Customer Reviews",
  "Artista musical": "Music Artist",
  "Creator digital": "Digital Creator",
  "Coach fitness": "Fitness Coach",
  "Finalmente, um link na bio que não parece igual ao de todo mundo. Minha taxa de conversão dobrou na primeira semana.": "Finally, a bio link that doesn't look like everyone else's. My conversion rate doubled in the first week.",
  "Os analytics finalmente fazem sentido. Consigo ver exatamente quais links geram vendas. Vale cada centavo.": "The analytics actually make sense. I can see exactly which links drive sales. Worth every penny.",
  "Troquei do Linktree e nunca mais voltei. Mais limpo, mais rápido e minha audiência amou o design.": "Switched from Linktree and never looked back. Cleaner, faster, and my audience loves the design.",
  "Não confie só no que a gente diz. Veja o que usuários reais têm a dizer.": "Don't take our word for it. Here's what real users have to say.",
  "Somos feitos para creators que querem crescer e monetizar. Isso significa analytics limpo de verdade, ferramentas de pagamento embutidas e zero bloat. Além disso, somos mais rápidos, mais acessíveis e não vendemos seus dados.": "We're built specifically for creators who want to grow and monetize. That means cleaner analytics you'll actually use, built-in payment tools, and zero bloat. Plus, we're faster, more affordable, and we don't sell your data.",
  "Com certeza! Usuários do plano Pro podem conectar o próprio domínio (como links.seunome.com). Cuidamos da parte técnica — é só apontar seu DNS e pronto.": "Absolutely! Pro plan users can connect their own custom domain (like links.yourname.com). We handle all the technical setup — just point your DNS and you're live.",
  "Aceitamos os principais cartões de crédito via Stripe. Para planos anuais, também aceitamos PayPal. Todos os pagamentos são processados com segurança e criptografia de nível bancário.": "We accept all major credit cards through Stripe. For annual plans, we also support PayPal. All payments are processed securely with bank-level encryption.",
  "Sim! O plano Pro inclui mini-loja. Você pode vender produtos digitais, receber gorjetas e coletar pagamentos — tudo sem sair da sua bio page. Integração com Stripe para pagamentos seguros.": "Yes! Our Pro plan includes a mini-store feature. You can sell digital products, accept tips, or collect payments — all without leaving your bio page. We integrate with Stripe for secure payments.",
  "Sua página continua no ar! Se fizer downgrade, recursos premium são desativados, mas seus links continuam ativos. Se cancelar totalmente, sua página volta para o plano grátis. Nenhum dado é apagado.": "Your page stays live! If you downgrade, premium features will be disabled but your links remain active. If you cancel entirely, your page converts to a free plan. No data is ever deleted.",
  "Sim, oferecemos garantia de reembolso de 7 dias em todos os planos pagos. Se o qlivar não for ideal para você, é só falar com a gente e devolvemos o pagamento — sem burocracia.": "Yes, we offer a 7-day money-back guarantee on all paid plans. If qlivar isn't right for you, just reach out and we'll refund your payment — no questions asked.",
  "Entre em contato com a gente": "Reach out to us",
  "Plano grátis": "Free",
  "para sempre": "forever",
  "Tudo que você precisa para começar — totalmente grátis": "Everything you need to start — completely free",
  "1 bio page": "1 bio page",
  "Até 5 links": "Up to 5 links",
  "Temas básicos": "Basic themes",
  "URL qlivar.com/username": "qlivar.com/username URL",
  "Suporte padrão": "Standard support",
  "Apenas analytics básico": "Basic analytics only",
  "Começar no grátis": "Start for Free",
  "Para creators prontos para crescer": "For creators ready to grow",
  "Links ilimitados": "Unlimited links",
  "Todos os temas": "All themes",
  "Temas básicos disponíveis": "Available basic themes",
  "Cores e fontes personalizadas": "Custom colors & fonts",
  "Analytics de cliques": "Click analytics",
  "Remover marca qlivar": "Remove qlivar branding",
  "Suporte prioritário": "Priority support",
  "Miniaturas personalizadas para links": "Custom link thumbnails",
  "Coleta de e-mails": "Email collection",
  "Obter Starter": "Get Starter",
  "Para profissionais que monetizam": "For pros who monetize",
  "Tudo do Starter": "Everything in Starter",
  "Insights de audiência": "Audience insights",
  "Mini-loja (venda de produtos)": "Mini-store (sell products)",
  "Coleta de pagamentos": "Payment collection",
  "Domínio personalizado": "Custom domain",
  "Agendamento e expiração de links": "Scheduling & link expiry",
  "Teste A/B": "A/B testing",
  "Ir de Pro": "Go Pro",
  "Para times escalando com IA": "For teams scaling with AI",
  "Tudo do Pro": "Everything in Pro",
  "Agente IA": "AI Agent",
  "Inteligência de negócios com IA": "AI business intelligence",
  "Qualificação de leads com IA": "AI lead qualification",
  "Recursos de IA prioritários": "Priority AI resources",
  "Suporte white-glove": "White-glove support",
  "Obter Business": "Get Business",
  "Preço simples.": "Simple pricing.",
  "Valor real.": "Real value.",
  "Sem taxas escondidas. Sem surpresas. Só preço direto que cresce com você.": "No hidden fees. No surprises. Just straightforward pricing that grows with you.",
  "Fazer upgrade para": "Upgrade to",
  "Mudar para": "Switch to",
  "Cancele quando quiser • Sem taxas escondidas": "Cancel anytime • No hidden fees",
  // ── Toast / notification strings (hooks without language context) ──
  "Falha ao carregar variantes A/B": "Failed to load A/B test variants",
  "Variante adicionada com sucesso": "Variant added successfully",
  "Falha ao adicionar variante": "Failed to add variant",
  "Falha ao atualizar variante": "Failed to update variant",
  "Variante excluída": "Variant deleted",
  "Falha ao excluir variante": "Failed to delete variant",
  "Falha ao adicionar produto": "Failed to add product",
  "Produto adicionado!": "Product added!",
  "Falha ao atualizar produto": "Failed to update product",
  "Produto atualizado!": "Product updated!",
  "Falha ao excluir produto": "Failed to delete product",
  "Produto excluído": "Product deleted",
  "Faça login para assinar": "Please sign in to subscribe",
  "Falha ao iniciar checkout. Tente novamente.": "Failed to start checkout. Please try again.",
  "Você já utilizou o período de teste gratuito para este plano. A cobrança será imediata.": "You have already used the free trial for this plan. You will be charged immediately.",
  "Faça login para gerenciar sua assinatura": "Please sign in to manage your subscription",
  "Insira um nome para o tema": "Please enter a theme name",
  "Configure e ative seu assistente antes de exibi-lo na bio.": "Set up and enable your assistant before showing it on your bio.",
  "Tutoriais": "Tutorials",
  "Mostrar barra": "Show toolbar",
  "Ocultar barra": "Hide toolbar",
  "Fechar chat": "Close chat",
  "Testar chatbot": "Test chatbot",
  "Fechar preview do chat": "Close chat preview",
  "Testar chatbot ao vivo": "Test live chatbot",
  "Erro ao carregar dados": "Error loading data",
  "Erro ao adicionar link": "Error adding link",
  "Link adicionado!": "Link added!",
  "Erro ao atualizar link": "Error updating link",
  "Erro ao excluir link": "Error deleting link",
  "Link excluído": "Link deleted",
  "Erro ao salvar configurações": "Error saving settings",
  "Alteração de usuário bloqueada": "Username change blocked",
  "Nome de usuário indisponível": "Username unavailable",
  "Erro ao salvar perfil": "Error saving profile",
  "Perfil salvo!": "Profile saved!",
  "Erro ao enviar foto": "Error uploading photo",
  "Erro ao enviar imagem": "Error uploading image",
  "Imagem removida": "Image removed",
  "Erro ao remover imagem": "Error removing image",
  "Imagem de fundo carregada": "Background image uploaded",
  "Armazenamento indisponível": "Storage unavailable",
  "Campos indisponíveis": "Fields unavailable",
  "Erro ao enviar imagem de fundo": "Error uploading background image",
  "Imagem de fundo removida": "Background image removed",
  "Erro ao remover imagem de fundo": "Error removing background image",
  "Vídeo de fundo carregado": "Background video uploaded",
  "Erro ao enviar vídeo de fundo": "Error uploading background video",
  "Vídeo de fundo removido": "Background video removed",
  "Erro ao remover vídeo de fundo": "Error removing background video",
  "Nome já em uso": "Name already in use",
  "Erro ao salvar tema": "Error saving theme",
  "Tema salvo!": "Theme saved!",
  "Tema não encontrado": "Theme not found",
  "Erro ao atualizar tema": "Error updating theme",
  "Erro ao excluir tema": "Error deleting theme",
  "Tema excluído": "Theme deleted",
  "Digite um código promocional": "Enter a promo code",
  "Não foi possível resgatar o código.": "Could not redeem code.",
  "Código resgatado com sucesso!": "Code redeemed successfully!",
  "Erro ao resgatar código.": "Error redeeming code.",
  "Configurações salvas!": "Settings saved!",
  "Agente criado!": "Agent created!",
  "Erro ao salvar": "Error saving",
};

const EN_TO_PT: Record<string, string> = Object.entries(PT_TO_EN).reduce((acc, [pt, en]) => {
  acc[en] = pt;
  return acc;
}, {} as Record<string, string>);

const PARTIAL_REPLACEMENTS: Array<{ from: RegExp; to: string }> = [
  { from: /^Sign out$/i, to: "Sair" },
  { from: /^Sign in$/i, to: "Entrar" },
  { from: /^Welcome back(,\s*.+)?!?$/i, to: "Bem-vindo de volta$1!" },
  { from: /^Here's how your bio page is performing\.$/i, to: "Veja como sua bio page está performando." },
  { from: /^Loading your dashboard\.\.\.$/i, to: "Carregando seu dashboard..." },
  { from: /^Back to\s+/i, to: "Voltar para " },
  { from: /^No Analytics Data Yet$/i, to: "Sem dados de analytics ainda" },
  { from: /^No Advanced Analytics Data Yet$/i, to: "Sem dados de analytics avançado ainda" },
  { from: /^No Link Data Yet$/i, to: "Sem dados de links ainda" },
  { from: /^No Traffic Sources Yet$/i, to: "Sem fontes de tráfego ainda" },
  { from: /^No Geographic Data Yet$/i, to: "Sem dados geográficos ainda" },
  { from: /^No Device Data Yet$/i, to: "Sem dados de dispositivo ainda" },
  { from: /^No Browser Data Yet$/i, to: "Sem dados de navegador ainda" },
  { from: /^No Products Yet$/i, to: "Sem produtos ainda" },
  { from: /^No Subscribers Yet$/i, to: "Sem inscritos ainda" },
  { from: /^Buy Now$/i, to: "Comprar agora" },
  { from: /^Coming soon$/i, to: "Em breve" },
  { from: /^Share Preview$/i, to: "Compartilhar prévia" },
  { from: /^Preview & Sharing Options$/i, to: "Opções de prévia e compartilhamento" },
  { from: /^Create your own bio page\s*→?$/i, to: "Crie sua bio page →" },
  { from: /^Shared Preview - This is a temporary preview link$/i, to: "Prévia compartilhada - este é um link temporário" },
  { from: /^Preview Mode - This page is not published yet\. Only you can see it\.$/i, to: "Modo de prévia - esta página ainda não está publicada. Só você pode vê-la." },
  { from: /^Contact page not available$/i, to: "Página de contato indisponível" },
  { from: /^Back to bio page$/i, to: "Voltar para a bio page" },
  { from: /^Back to bio$/i, to: "Voltar para bio" },
  { from: /^No products available yet\.?$/i, to: "Nenhum produto disponível no momento." },
  { from: /^No links yet$/i, to: "Sem links ainda" },
  { from: /^Loading your dashboard\.\.\.$/i, to: "Carregando seu dashboard..." },
  { from: /^This feature requires the (\w+) plan$/i, to: "Este recurso exige o plano $1" },
  { from: /^Applied theme: (.+)$/i, to: "Tema aplicado: $1" },
];

const PARTIAL_REPLACEMENTS_EN: Array<{ from: RegExp; to: string }> = [
  { from: /^Sair$/i, to: "Log out" },
  { from: /^Entrar$/i, to: "Sign in" },
  { from: /^Bem-vindo de volta(,\s*.+)?!?$/i, to: "Welcome back$1!" },
  { from: /^Veja como sua bio page está performando\.$/i, to: "Here's how your bio page is performing." },
  { from: /^Voltar para\s+/i, to: "Back to " },
  { from: /^Sem dados de analytics ainda$/i, to: "No Analytics Data Yet" },
  { from: /^Sem dados de analytics avançado ainda$/i, to: "No Advanced Analytics Data Yet" },
  { from: /^Sem dados de links ainda$/i, to: "No Link Data Yet" },
  { from: /^Sem fontes de tráfego ainda$/i, to: "No Traffic Sources Yet" },
  { from: /^Sem dados geográficos ainda$/i, to: "No Geographic Data Yet" },
  { from: /^Sem dados de dispositivo ainda$/i, to: "No Device Data Yet" },
  { from: /^Sem dados de navegador ainda$/i, to: "No Browser Data Yet" },
  { from: /^Sem produtos ainda$/i, to: "No Products Yet" },
  { from: /^Sem inscritos ainda$/i, to: "No Subscribers Yet" },
  { from: /^Comprar agora$/i, to: "Buy Now" },
  { from: /^Em breve$/i, to: "Coming soon" },
  { from: /^Compartilhar prévia$/i, to: "Share Preview" },
  { from: /^Opções de prévia e compartilhamento$/i, to: "Preview & Sharing Options" },
  { from: /^Crie sua bio page\s*→?$/i, to: "Create your own bio page →" },
  { from: /^Prévia compartilhada - este é um link temporário$/i, to: "Shared Preview - This is a temporary preview link" },
  { from: /^Modo de prévia - esta página ainda não está publicada\. Só você pode vê-la\.$/i, to: "Preview Mode - This page is not published yet. Only you can see it." },
  { from: /^Página de contato indisponível$/i, to: "Contact page not available" },
  { from: /^Voltar para a bio page$/i, to: "Back to bio page" },
  { from: /^Voltar para bio$/i, to: "Back to bio" },
  { from: /^Nenhum produto disponível no momento\.?$/i, to: "No products available yet." },
  { from: /^Sem links ainda$/i, to: "No links yet" },
  { from: /^Carregando seu dashboard\.\.\.$/i, to: "Loading your dashboard..." },
  { from: /^Este recurso exige o plano (\w+)$/i, to: "This feature requires the $1 plan" },
  { from: /^Tema aplicado: (.+)$/i, to: "Applied theme: $1" },
  { from: /^Tema atualizado: (.+)$/i, to: "Theme updated: $1" },
];

const ATTRS_TO_TRANSLATE = ["placeholder", "aria-label", "title"] as const;

function shouldSkipRuntimeTranslation(target: Node | null) {
  if (!target) return false;

  const element = target instanceof Element
    ? target
    : target instanceof Text
      ? target.parentElement
      : null;

  if (!element) return false;
  return !!element.closest("[data-no-runtime-i18n]");
}

function translateValue(value: string, language: AppLanguage) {
  if (!value) return value;
  const trimmed = value.trim();
  if (!trimmed) return value;

  if (language === "pt") {
    if (EN_TO_PT[trimmed]) return value.replace(trimmed, EN_TO_PT[trimmed]);
    for (const replacement of PARTIAL_REPLACEMENTS) {
      if (replacement.from.test(trimmed)) return value.replace(trimmed, trimmed.replace(replacement.from, replacement.to));
    }
    return value;
  }

  if (PT_TO_EN[trimmed]) return value.replace(trimmed, PT_TO_EN[trimmed]);
  for (const replacement of PARTIAL_REPLACEMENTS_EN) {
    if (replacement.from.test(trimmed)) return value.replace(trimmed, trimmed.replace(replacement.from, replacement.to));
  }
  return value;
}

function translateTextNode(node: Text, language: AppLanguage) {
  if (shouldSkipRuntimeTranslation(node)) return;

  const current = node.nodeValue || "";
  const translated = translateValue(current, language);
  if (translated !== current) {
    node.nodeValue = translated;
  }
}

function translateElementAttributes(element: Element, language: AppLanguage) {
  if (!(element instanceof HTMLElement)) return;
  if (shouldSkipRuntimeTranslation(element)) return;

  ATTRS_TO_TRANSLATE.forEach((attr) => {
    const current = element.getAttribute(attr);
    if (!current) return;
    const translated = translateValue(current, language);
    if (translated !== current) {
      element.setAttribute(attr, translated);
    }
  });
}

export function applyRuntimeTranslations(language: AppLanguage, root: ParentNode = document.body) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let node = walker.nextNode();

  while (node) {
    translateTextNode(node as Text, language);
    node = walker.nextNode();
  }

  if (root instanceof Element || root instanceof Document) {
    const elements = (root instanceof Document ? root.body : root).querySelectorAll("*");
    elements.forEach((element) => translateElementAttributes(element, language));
  }
}
